 <template>
  <div class="container">
    <div class="row">
      <div
        class="col-lg-3 col-sm-6 col-12"
        v-for="(obj, idx) in value"
        :key="obj.url + '-' + scope + '-' + idx"
        style="padding: 5px;"
      >
        <div class="img-container">
          <img
            class="image"
            v-preview:{{scope}}
            v-lazy-image
            :data-src="obj.url"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "ImageAlbum",
  props: {
    value: {
      type: Array[Object],
      default: [],
    },
    scope: {
      type: String,
      default: "default",
    },
  },
  data() {
    return {};
  },
  created() {
  },
  mounted() {},
  computed: {},
  methods: {},
  watch: {},
};
</script>

<style scoped>
.img-container {
  width: 100%;
  padding-top: 56.25%;
  position: relative;
}

.image {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%; 
  height: 100%; 
  object-fit: cover;
  cursor: pointer;
}

</style>